<template>
  <v-card flat style="background-color:#e9e9e9;">
   
    <v-tabs  fixed-tabs elevation-0  style="background-color:#e9e9e9;">
      <v-tab @change="changetab('Status Master')">
        <v-icon left>
          mdi-bank
        </v-icon>
        Status Master
      </v-tab>

      <v-tab @change="changetab('Reason Master')">
        <v-icon left>
          mdi-account
        </v-icon>
        Reason Master
      </v-tab>

       <v-tab @change="changetab('Status + Reason - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Status + Reason
      </v-tab>

 <v-tab @change="changetab('Event + Status - Mapping')">
        <v-icon left>
          mdi-account-network
        </v-icon>
       Event + Status
      </v-tab>

      

 <v-tab @change="changetab('Reason Master')">
        <v-icon left>
          mdi-account
        </v-icon>
        Event + Reason
      </v-tab>

     


      

      <v-tab-item >
        <status></status>
      </v-tab-item>
       <v-tab-item>
        <Reason></Reason>
      </v-tab-item>
       <v-tab-item style="background-color:#e9e9e9;">
      <EventReasonmerge></EventReasonmerge>
      </v-tab-item>
       <v-tab-item style="background-color:#e9e9e9;">
       <Eventstatusmerge></Eventstatusmerge>
      </v-tab-item>
      <v-tab-item>
        <!-- -->
         <statusreasonmerge></statusreasonmerge>
         
      </v-tab-item>



     
      
    </v-tabs>
  </v-card>
</template>
<script>
import status from '../../../components/status'
import Reason from '../../../components/reason'
import statusreasonmerge from '../../../components/statusreasonmerge.vue'
import Eventstatusmerge from '../../../components/EventStatusmerge.vue'
import EventReasonmerge from '../../../components/EventReasonmerge.vue'
export default {
 components: {status,Reason,statusreasonmerge,Eventstatusmerge,EventReasonmerge},
  methods:{
    changetab: function(pagename) {
        this.$store.commit("setPageTitle", pagename);
    }
 }
  
}
</script>